import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe, CommonModule, TitleCasePipe } from '@angular/common';
import { DeclarationsAuthService } from '../auth/declarations-auth.service';
import { NameMustMatchDirective, valuesMatch } from '../shared/name-must-match.directive';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BlockCopyPasteDirective } from '../shared/block-copy-paste.directive';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';

@Component({
  selector: 'ad-external-business-interest-declaration-ack-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">ACKNOWLEDGMENT</h4>
    </div>
    <div class="modal-body">
      <p>Acknowledgement and Confirmation by the Employee</p>
      <div class="mb-3">
        <label class="form-label">Please input your full name</label>
        <ejs-textbox
          [(ngModel)]="data.name"
          placeholder="Please input your full name"
          adBlockCopyPaste
          [adNameMustMatch]="nameToMatch"
          (change)="submitDisabled = !valuesMatch(data.name, nameToMatch)"
        ></ejs-textbox>
        <small class="form-text text-muted"
          >Must match your full name in the corporate directory ({{ nameToMatch }})</small
        >
      </div>
      <p class="mt-3">
        <strong>{{ data.declarationDate | date }}</strong>
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="handleClose()" [disabled]="submitDisabled">SUBMIT</button>
    </div>
  `,
  providers: [TitleCasePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BlockCopyPasteDirective,
    CommonModule,
    DatePipe,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    NameMustMatchDirective,
    TextBoxModule
  ]
})
export class ExternalBusinessInterestDeclarationAckDialogComponent implements OnInit {
  @Input() data: any = {};
  @Output() closeDialog = new EventEmitter<any>();

  protected submitDisabled = true;
  protected nameToMatch = '';
  protected valuesMatch = valuesMatch;

  constructor(
    public authService: DeclarationsAuthService,
    private titleCasePipe: TitleCasePipe
  ) {}

  public ngOnInit(): void {
    this.authService.getActiveAccount$().subscribe((account) => {
      this.nameToMatch = account?.name || '';
      this.submitDisabled = !valuesMatch(this.data.name, this.nameToMatch);
    });
  }

  public handleClose() {
    this.data.name = this.titleCasePipe.transform(this.data.name);
    this.closeDialog.emit(this.data);
  }
}
